/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const HubAgentOverallStatus = {
    PENDING_COMMISSIONING: "PENDING_COMMISSIONING",
    COMMISSIONING: "COMMISSIONING",
    FAILED_COMMISSIONING: "FAILED_COMMISSIONING",
    CONNECTED: "CONNECTED",
    OPTIMISING: "OPTIMISING",
    CRITICAL: "CRITICAL",
    UNREACHABLE: "UNREACHABLE",
};
export const HubAgentStatus = {
    PENDING_COMMISSIONING: "PENDING_COMMISSIONING",
    COMMISSIONING: "COMMISSIONING",
    FAILED_COMMISSIONING: "FAILED_COMMISSIONING",
    IDLE: "IDLE",
    OPTIMISING: "OPTIMISING",
    FAILED: "FAILED",
};
export const HubAlphaSchedulerTaskStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
    DONE: "DONE",
};
export const HubAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const HubAnnotationSourceKind = {
    USER: "USER",
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
    UNKNOWN: "UNKNOWN",
    CUSTOM: "CUSTOM",
};
export const HubAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const HubArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const HubAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
    COMMISSIONED_INDURION_AGENT: "COMMISSIONED_INDURION_AGENT",
};
export const HubBrandingItemId = {
    Logo: "logo",
    Favicon: "favicon",
    PrimaryColor: "primaryColor",
    CookiePolicy: "cookiePolicy",
    PrivacyPolicy: "privacyPolicy",
    TermsAndConditions: "termsAndConditions",
    OnScreenText: "onScreenText",
    DocumentationUrl: "documentationUrl",
};
export const HubBrandingType = {
    Color: "color",
    File: "file",
    Url: "url",
};
export const HubBuildState = {
    CHECKING_COMPATIBILITY: "CHECKING_COMPATIBILITY",
    PENDING: "PENDING",
    READY: "READY",
    FAILED: "FAILED",
    DELETING: "DELETING",
    DELETED: "DELETED",
};
export const HubCameraConfigStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
};
export const HubCameraStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
};
export const HubCameraType = {
    BASLER: "BASLER",
    ALLIED_VISION: "ALLIED_VISION",
    GENICAM: "GENICAM",
};
export const HubCommissioningRequestFilter = {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    PENDING: "PENDING",
};
export const HubDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const HubDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const HubDecisionOutcome = {
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
};
export const HubDefaultExamplePickingStrategy = {
    LATEST: "LATEST",
    RANDOM: "RANDOM",
    SELECTION: "SELECTION",
    SINGLESOURCE: "SINGLESOURCE",
};
export const HubDeleteCleanupStatus = {
    Pending: "pending",
    Aborted: "aborted",
};
export const HubDeploymentStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
};
export const HubEntitlementState = {
    Granted: "granted",
    Lapsed: "lapsed",
    Suspended: "suspended",
    NotGranted: "not_granted",
};
export const HubExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const HubExampleStreamDefinitionType = {
    SAMPLE_DEFINITION: "SAMPLE_DEFINITION",
    EXAMPLE_DEFINITION: "EXAMPLE_DEFINITION",
};
export const HubExampleStreamRunningTaskKind = {
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
};
export const HubExampleStreamStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
    RECORDING: "RECORDING",
    VALIDATING: "VALIDATING",
    INFERENCE: "INFERENCE",
    UNAVAILABLE: "UNAVAILABLE",
    INVALID: "INVALID",
};
export const HubFeature = {
    IndurionAgent: "indurion_agent",
    AreaMeasurement: "area_measurement",
    DataDrift: "data_drift",
};
export const HubFileEncoding = {
    Plain: "plain",
    Base64: "base64",
};
export const HubImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const HubJobKind = {
    ModelTraining: "modelTraining",
    ModelFinetuning: "modelFinetuning",
    AnnotationPrediction: "annotationPrediction",
    AnnotationComparison: "annotationComparison",
    CameraCalibration: "cameraCalibration",
    Recording: "recording",
    DriftDetection: "driftDetection",
    Custom: "custom",
};
export const HubJobStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    FAILED: "FAILED",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
};
export const HubKeyRevokeStatus = {
    Pending: "pending",
};
export const HubLogLevel = {
    SYSTEM_STATUS: "SYSTEM_STATUS",
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR",
};
export const HubMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
export const HubPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const HubPlatformConnectionStatus = {
    CONNECTING: "CONNECTING",
    HEALTHY: "HEALTHY",
    UNHEALTHY: "UNHEALTHY",
    UNKNOWN: "UNKNOWN",
    DISCONNECTED: "DISCONNECTED",
};
export const HubPlatformDeploymentActualStatus = {
    PUSHED: "PUSHED",
    RUNNING: "RUNNING",
    STOPPED: "STOPPED",
    PUSHING: "PUSHING",
    OPTIMISING: "OPTIMISING",
    STARTING: "STARTING",
    STOPPING: "STOPPING",
    FAILED: "FAILED",
};
export const HubPlatformDeploymentCreateErrorCode = {
    PLATFORM_DEPLOYMENT_ALREADY_EXISTS: "PLATFORM_DEPLOYMENT_ALREADY_EXISTS",
    CHILD_PLATFORM_DOES_NOT_EXIST: "CHILD_PLATFORM_DOES_NOT_EXIST",
    PARENT_PLATFORM_DOES_NOT_EXIST: "PARENT_PLATFORM_DOES_NOT_EXIST",
    PARENT_DEPLOYMENT_DOES_NOT_EXIST: "PARENT_DEPLOYMENT_DOES_NOT_EXIST",
    CHILD_PLATFORM_TYPE_NOT_SUPPORTED: "CHILD_PLATFORM_TYPE_NOT_SUPPORTED",
    AGENT_LICENSE_LIMIT_REACHED: "AGENT_LICENSE_LIMIT_REACHED",
    AGENT_LICENSE_INVALID: "AGENT_LICENSE_INVALID",
    INFERENCE_SLOT_ID_REQUIRED: "INFERENCE_SLOT_ID_REQUIRED",
    INFERENCE_SLOT_NOT_FOUND: "INFERENCE_SLOT_NOT_FOUND",
    INFERENCE_SLOT_NOT_REGISTERED: "INFERENCE_SLOT_NOT_REGISTERED",
    INFERENCE_SLOT_RUNNING: "INFERENCE_SLOT_RUNNING",
    AGENT_NOT_CONNECTED: "AGENT_NOT_CONNECTED",
    INFERENCE_SETUP_ALREADY_IN_ANOTHER_SLOT: "INFERENCE_SETUP_ALREADY_IN_ANOTHER_SLOT",
};
export const HubPlatformDeploymentDeleteErrorCode = {
    NOT_FOUND: "NOT_FOUND",
    PROTECTED_STATUS: "PROTECTED_STATUS",
};
export const HubPlatformDeploymentDesiredStatus = {
    PUSHED: "PUSHED",
    RUNNING: "RUNNING",
    STOPPED: "STOPPED",
};
export const HubPlatformDeploymentErrorCode = {
    IMPORT_FAILED: "IMPORT_FAILED",
    IMPORT_STOPPED: "IMPORT_STOPPED",
    DEPLOYMENT_START_FAILED: "DEPLOYMENT_START_FAILED",
    DEPLOYMENT_STOP_FAILED: "DEPLOYMENT_STOP_FAILED",
};
export const HubPlatformDeploymentRole = {
    PARENT: "PARENT",
    CHILD: "CHILD",
};
export const HubPlatformType = {
    RvaiHub: "rvai_hub",
    RvaiIndurionAgent: "rvai_indurion_agent",
    RvaiHeadlessAgent: "rvai_headless_agent",
};
export const HubPleoraLicenseStatus = {
    VALID: "VALID",
    MAC_NOT_FOUND: "MAC_NOT_FOUND",
    INVALID_FORMAT: "INVALID_FORMAT",
};
export const HubResourceKind = {
    PARAMETERS: "PARAMETERS",
    EXAMPLES: "EXAMPLES",
    DATASET: "DATASET",
    DATAPOOL: "DATAPOOL",
    MODEL: "MODEL",
    BLOB: "BLOB",
};
export const HubSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const HubStorageCapacityServiceId = {
    Algorithm: "algorithm",
    Data: "data",
    Database: "database",
    Resources: "resources",
};
export const HubStorageCapacityStatus = {
    NORMAL: "NORMAL",
    WARNING: "WARNING",
    ALARM: "ALARM",
};
export const HubWorkflowStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    DELETING: "DELETING",
    STOPPED: "STOPPED",
    DONE: "DONE",
    FAILED: "FAILED",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = async ({ secure, path, type, query, format, body, ...params }) => {
            const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = format || this.format || undefined;
            if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
                body = this.createFormData(body);
            }
            if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
                body = qs.stringify(body);
            }
            if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
                body = JSON.stringify(body);
            }
            return this.instance.request({
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                },
                params: query,
                responseType: responseFormat,
                data: body,
                url: path,
            });
        };
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/hub/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
/**
 * @title RVAI Hub
 * @version 5.15.0
 * @baseUrl /hub/api/v1
 */
export class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.algorithms = {
            /**
             * @description List algorithms. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name ListAlgorithms
             * @summary List Algorithms
             * @request GET:/algorithms
             * @secure
             */
            listAlgorithms: (query, params = {}) => this.request({
                path: `/algorithms`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List algorithm fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name ListAlgorithmFields
             * @summary List Algorithm Fields
             * @request GET:/algorithms/fields
             * @secure
             */
            listAlgorithmFields: (params = {}) => this.request({
                path: `/algorithms/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a new algorithm by uploading thumbnail and algorithm spec. The algorithm image should be prebuilt and pushed to the docker registry. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name CreateNewAlgorithmPrebuilt
             * @summary Create New Algorithm Prebuilt
             * @request POST:/algorithms/prebuilt
             * @secure
             */
            createNewAlgorithmPrebuilt: (data, query, params = {}) => this.request({
                path: `/algorithms/prebuilt`,
                method: "POST",
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithms registry details. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithmsRegistry
             * @summary Get Algorithms Registry
             * @request GET:/algorithms/registry
             * @secure
             */
            getAlgorithmsRegistry: (params = {}) => this.request({
                path: `/algorithms/registry`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List algorithm types. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name ListAlgorithmTypes
             * @summary List Algorithm Types
             * @request GET:/algorithms/types
             * @secure
             */
            listAlgorithmTypes: (params = {}) => this.request({
                path: `/algorithms/types`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithm type. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithmType
             * @summary Get Algorithm Type
             * @request GET:/algorithms/types/{algorithm_type}
             * @secure
             */
            getAlgorithmType: (algorithmType, params = {}) => this.request({
                path: `/algorithms/types/${algorithmType}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithm type thumbnail. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithmTypeThumbnail
             * @summary Get Algorithm Type Thumbnail
             * @request GET:/algorithms/types/{algorithm_type}/thumbnail
             * @secure
             */
            getAlgorithmTypeThumbnail: (algorithmType, params = {}) => this.request({
                path: `/algorithms/types/${algorithmType}/thumbnail`,
                method: "GET",
                secure: true,
                format: "blob",
                ...params,
            }),
            /**
             * @description List daemons for algorithm. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags daemons
             * @name ListAlgorithmDaemons
             * @summary List Algorithm Daemons
             * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons
             * @secure
             */
            listAlgorithmDaemons: (algorithmId, algorithmVersion, params = {}) => this.request({
                path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a daemon. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags daemons
             * @name GetDaemon
             * @summary Get Daemon
             * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons/{definition_id}
             * @secure
             */
            getDaemon: (algorithmId, algorithmVersion, definitionId, params = {}) => this.request({
                path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons/${definitionId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete an algorithm. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name DeleteAlgorithm
             * @summary Delete Algorithm
             * @request DELETE:/algorithms/{id}/{version}
             * @secure
             */
            deleteAlgorithm: (id, version, query, params = {}) => this.request({
                path: `/algorithms/${id}/${version}`,
                method: "DELETE",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithm. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithm
             * @summary Get Algorithm
             * @request GET:/algorithms/{id}/{version}
             * @secure
             */
            getAlgorithm: (id, version, params = {}) => this.request({
                path: `/algorithms/${id}/${version}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithm definition. If the original flag is set to True, the definition will be returned in the same schema version as it was created by the originating algorithm. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithmDefinition
             * @summary Get Algorithm Definition
             * @request GET:/algorithms/{id}/{version}/definition
             * @secure
             */
            getAlgorithmDefinition: (id, version, query, params = {}) => this.request({
                path: `/algorithms/${id}/${version}/definition`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get algorithm thumbnail. Supports authorization via ?token. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags algorithms
             * @name GetAlgorithmThumbnail
             * @summary Get Algorithm Thumbnail
             * @request GET:/algorithms/{id}/{version}/thumbnail
             * @secure
             */
            getAlgorithmThumbnail: (id, version, query, params = {}) => this.request({
                path: `/algorithms/${id}/${version}/thumbnail`,
                method: "GET",
                query: query,
                secure: true,
                format: "blob",
                ...params,
            }),
        };
        this.alpha = {
            /**
             * @description Retrieve calibration resources for the specified camera. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags alpha, cameras
             * @name ListCameraCalibrationResources
             * @summary List Camera Calibration Resources
             * @request GET:/alpha/cameras/{camera_id}/calibration-resources
             * @secure
             */
            listCameraCalibrationResources: (cameraId, query, params = {}) => this.request({
                path: `/alpha/cameras/${cameraId}/calibration-resources`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description If there is a calibration resource for a specified example stream in a project, return the most recent one. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags alpha, example_streams
             * @name ListProjectCalibrationResourcesPerCameraConfig
             * @summary List Project Calibration Resources Per Camera Config
             * @request GET:/alpha/example-streams/{example_stream_id}/calibration-resources/{project_id}/most-recent
             * @secure
             */
            listProjectCalibrationResourcesPerCameraConfig: (projectId, exampleStreamId, query, params = {}) => this.request({
                path: `/alpha/example-streams/${exampleStreamId}/calibration-resources/${projectId}/most-recent`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags alpha, scheduler
             * @name ListSchedulerTasks
             * @summary List Scheduler Tasks
             * @request GET:/alpha/scheduler/tasks
             * @secure
             */
            listSchedulerTasks: (params = {}) => this.request({
                path: `/alpha/scheduler/tasks`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags alpha, scheduler
             * @name GetSchedulerEvents
             * @summary Get Scheduler Events
             * @request GET:/alpha/scheduler/tasks/sse
             * @secure
             */
            getSchedulerEvents: (params = {}) => this.request({
                path: `/alpha/scheduler/tasks/sse`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags alpha, scheduler
             * @name SaveSchedulerTaskLogs
             * @summary Save Scheduler Task Logs
             * @request POST:/alpha/scheduler/tasks/{task_id}/logs
             * @secure
             */
            saveSchedulerTaskLogs: (taskId, data, params = {}) => this.request({
                path: `/alpha/scheduler/tasks/${taskId}/logs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags alpha, scheduler
             * @name SetSchedulerTaskStatus
             * @summary Set Scheduler Task Status
             * @request PATCH:/alpha/scheduler/tasks/{task_id}/status
             * @secure
             */
            setSchedulerTaskStatus: (taskId, data, params = {}) => this.request({
                path: `/alpha/scheduler/tasks/${taskId}/status`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.branding = {
            /**
             * @description Full reset to defaults for the entire branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags branding
             * @name ResetToDefaults
             * @summary Reset To Defaults
             * @request DELETE:/branding
             * @secure
             */
            resetToDefaults: (params = {}) => this.request({
                path: `/branding`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags branding
             * @name UpdateBranding
             * @summary Update Branding
             * @request PUT:/branding
             * @secure
             */
            updateBranding: (data, params = {}) => this.request({
                path: `/branding`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Returns a list of all the branding items **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags branding
             * @name GetBrandingFields
             * @summary Get Branding Fields
             * @request GET:/branding/fields
             * @secure
             */
            getBrandingFields: (params = {}) => this.request({
                path: `/branding/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Import a branding configuration from a JSON file. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags branding
             * @name ImportBrandingConfig
             * @summary Import Branding Config
             * @request POST:/branding/import
             * @secure
             */
            importBrandingConfig: (data, query, params = {}) => this.request({
                path: `/branding/import`,
                method: "POST",
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Bulk update the branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags branding
             * @name BulkUpdateBranding
             * @summary Bulk Update Branding
             * @request PUT:/branding/json
             * @secure
             */
            bulkUpdateBranding: (data, query, params = {}) => this.request({
                path: `/branding/json`,
                method: "PUT",
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Returns all the overridden branding items. If an item is None, the default (robovision) branding should be shown.
             *
             * @tags branding
             * @name GetPublicBranding
             * @summary Get Public Branding
             * @request GET:/branding/public
             * @secure
             */
            getPublicBranding: (params = {}) => this.request({
                path: `/branding/public`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.cameras = {
            /**
             * @description List all cameras. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name ListCameras
             * @summary List Cameras
             * @request GET:/cameras
             * @secure
             */
            listCameras: (query, params = {}) => this.request({
                path: `/cameras`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name CreateCamera
             * @summary Create Camera
             * @request POST:/cameras
             * @secure
             */
            createCamera: (data, params = {}) => this.request({
                path: `/cameras`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name DeleteCamera
             * @summary Delete Camera
             * @request DELETE:/cameras/{camera_id}
             * @secure
             */
            deleteCamera: (cameraId, query, params = {}) => this.request({
                path: `/cameras/${cameraId}`,
                method: "DELETE",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get camera. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name GetCamera
             * @summary Get Camera
             * @request GET:/cameras/{camera_id}
             * @secure
             */
            getCamera: (cameraId, params = {}) => this.request({
                path: `/cameras/${cameraId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name UpdateCamera
             * @summary Update Camera
             * @request PATCH:/cameras/{camera_id}
             * @secure
             */
            updateCamera: (cameraId, data, params = {}) => this.request({
                path: `/cameras/${cameraId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Get camera config. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name GetCameraConfig
             * @summary Get Camera Config
             * @request GET:/cameras/{camera_id}/config
             * @secure
             */
            getCameraConfig: (cameraId, params = {}) => this.request({
                path: `/cameras/${cameraId}/config`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description Update camera activity. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name UpdateCameraStatus
             * @summary Update Camera Status
             * @request PUT:/cameras/{camera_id}/status
             * @secure
             */
            updateCameraStatus: (cameraId, query, params = {}) => this.request({
                path: `/cameras/${cameraId}/status`,
                method: "PUT",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags cameras
             * @name GetCameraThumbnail
             * @summary Get Camera Thumbnail
             * @request GET:/cameras/{camera_id}/thumbnail
             * @secure
             */
            getCameraThumbnail: (cameraId, params = {}) => this.request({
                path: `/cameras/${cameraId}/thumbnail`,
                method: "GET",
                secure: true,
                format: "blob",
                ...params,
            }),
        };
        this.classes = {
            /**
             * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags global_classes
             * @name DeleteClasses
             * @summary Delete Classes
             * @request DELETE:/classes
             * @secure
             */
            deleteClasses: (data, params = {}) => this.request({
                path: `/classes`,
                method: "DELETE",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List classess. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags global_classes
             * @name ListClasses
             * @summary List Classes
             * @request GET:/classes
             * @secure
             */
            listClasses: (query, params = {}) => this.request({
                path: `/classes`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create classes. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags global_classes
             * @name CreateClasses
             * @summary Create Classes
             * @request POST:/classes
             * @secure
             */
            createClasses: (data, params = {}) => this.request({
                path: `/classes`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List classes fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags global_classes
             * @name ListClassesFields
             * @summary List Classes Fields
             * @request GET:/classes/fields
             * @secure
             */
            listClassesFields: (params = {}) => this.request({
                path: `/classes/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags global_classes
             * @name DeleteClass
             * @summary Delete Class
             * @request DELETE:/classes/{id}
             * @secure
             */
            deleteClass: (id, params = {}) => this.request({
                path: `/classes/${id}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get class. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags global_classes
             * @name GetClass
             * @summary Get Class
             * @request GET:/classes/{id}
             * @secure
             */
            getClass: (id, params = {}) => this.request({
                path: `/classes/${id}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags global_classes
             * @name UpdateClass
             * @summary Update Class
             * @request PUT:/classes/{id}
             * @secure
             */
            updateClass: (id, data, params = {}) => this.request({
                path: `/classes/${id}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.clusters = {
            /**
             * @description Get compute clusters information.
             *
             * @tags monitor
             * @name GetComputeClusters
             * @summary Get Compute Clusters
             * @request GET:/clusters
             * @secure
             */
            getComputeClusters: (params = {}) => this.request({
                path: `/clusters`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.config = {
            /**
             * @description Modify platform config. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags monitor
             * @name ModifyPlatformConfig
             * @summary Modify Platform Config
             * @request POST:/config
             * @secure
             */
            modifyPlatformConfig: (data, params = {}) => this.request({
                path: `/config`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
        };
        this.customAnnotationSources = {
            /**
             * @description List custom annotation sources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name ListCustomAnnotationSources
             * @summary List Custom Annotation Sources
             * @request GET:/custom-annotation-sources
             * @secure
             */
            listCustomAnnotationSources: (query, params = {}) => this.request({
                path: `/custom-annotation-sources`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name CreateCustomAnnotationSource
             * @summary Create Custom Annotation Source
             * @request POST:/custom-annotation-sources
             * @secure
             */
            createCustomAnnotationSource: (data, params = {}) => this.request({
                path: `/custom-annotation-sources`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get custom annotation source by name. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name GetCustomAnnotationSourceByName
             * @summary Get Custom Annotation Source By Name
             * @request GET:/custom-annotation-sources/name/{name}
             * @secure
             */
            getCustomAnnotationSourceByName: (name, params = {}) => this.request({
                path: `/custom-annotation-sources/name/${name}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name DeleteCustomAnnotationSource
             * @summary Delete Custom Annotation Source
             * @request DELETE:/custom-annotation-sources/{id}
             * @secure
             */
            deleteCustomAnnotationSource: (id, params = {}) => this.request({
                path: `/custom-annotation-sources/${id}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get custom annotation source. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name GetCustomAnnotationSource
             * @summary Get Custom Annotation Source
             * @request GET:/custom-annotation-sources/{id}
             * @secure
             */
            getCustomAnnotationSource: (id, params = {}) => this.request({
                path: `/custom-annotation-sources/${id}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name UpdateCustomAnnotationSource
             * @summary Update Custom Annotation Source
             * @request PUT:/custom-annotation-sources/{id}
             * @secure
             */
            updateCustomAnnotationSource: (id, data, params = {}) => this.request({
                path: `/custom-annotation-sources/${id}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List custom annotation source fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags custom_annotation_sources
             * @name ListCustomAnnotationSourceFields
             * @summary List Custom Annotation Source Fields
             * @request GET:/custom-annotation_sources/fields
             * @secure
             */
            listCustomAnnotationSourceFields: (params = {}) => this.request({
                path: `/custom-annotation_sources/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.daemons = {
            /**
             * @description List daemons. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags daemons
             * @name ListDaemons
             * @summary List Daemons
             * @request GET:/daemons
             * @secure
             */
            listDaemons: (params = {}) => this.request({
                path: `/daemons`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.datapools = {
            /**
             * @description List datapools. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name ListDatapools
             * @summary List Datapools
             * @request GET:/datapools
             * @secure
             */
            listDatapools: (query, params = {}) => this.request({
                path: `/datapools`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a datapool in a project. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name CreateDatapool
             * @summary Create Datapool
             * @request POST:/datapools
             * @secure
             */
            createDatapool: (data, params = {}) => this.request({
                path: `/datapools`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List datapool fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name ListDatapoolFields
             * @summary List Datapool Fields
             * @request GET:/datapools/fields
             * @secure
             */
            listDatapoolFields: (params = {}) => this.request({
                path: `/datapools/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete datapool. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags datapools
             * @name DeleteDatapool
             * @summary Delete Datapool
             * @request DELETE:/datapools/{datapool_id}
             * @secure
             */
            deleteDatapool: (datapoolId, params = {}) => this.request({
                path: `/datapools/${datapoolId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get datapool. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name GetDatapool
             * @summary Get Datapool
             * @request GET:/datapools/{datapool_id}
             * @secure
             */
            getDatapool: (datapoolId, query, params = {}) => this.request({
                path: `/datapools/${datapoolId}`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get classes of this datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name GetDatapoolClasses
             * @summary Get Datapool Classes
             * @request GET:/datapools/{datapool_id}/classes
             * @secure
             */
            getDatapoolClasses: (datapoolId, params = {}) => this.request({
                path: `/datapools/${datapoolId}/classes`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update classes of this datapool. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
             *
             * @tags datapools
             * @name UpdateDatapoolClasses
             * @summary Update Datapool Classes
             * @request PUT:/datapools/{datapool_id}/classes
             * @secure
             */
            updateDatapoolClasses: (datapoolId, data, params = {}) => this.request({
                path: `/datapools/${datapoolId}/classes`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a dataset. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags datasets
             * @name CreateDataset
             * @summary Create Dataset
             * @request POST:/datapools/{datapool_id}/datasets
             * @secure
             */
            createDataset: (datapoolId, data, params = {}) => this.request({
                path: `/datapools/${datapoolId}/datasets`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a dataset split. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags datasets
             * @name CreateSplit
             * @summary Create Split
             * @request POST:/datapools/{datapool_id}/datasets/splits
             * @secure
             */
            createSplit: (datapoolId, data, params = {}) => this.request({
                path: `/datapools/${datapoolId}/datasets/splits`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List datapool sources for filtered samples. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name ListFilteredDatapoolSources
             * @summary List Filtered Datapool Sources
             * @request POST:/datapools/{datapool_id}/filtered-sources
             * @secure
             */
            listFilteredDatapoolSources: (datapoolId, data, params = {}) => this.request({
                path: `/datapools/${datapoolId}/filtered-sources`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List datapool sources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
             *
             * @tags datapools
             * @name ListDatapoolSources
             * @summary List Datapool Sources
             * @request GET:/datapools/{datapool_id}/sources
             * @secure
             */
            listDatapoolSources: (datapoolId, query, params = {}) => this.request({
                path: `/datapools/${datapoolId}/sources`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.datasets = {
            /**
             * @description List datasets. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
             *
             * @tags datasets
             * @name ListDatasets
             * @summary List Datasets
             * @request GET:/datasets
             * @secure
             */
            listDatasets: (query, params = {}) => this.request({
                path: `/datasets`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List dataset fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
             *
             * @tags datasets
             * @name ListDatasetFields
             * @summary List Dataset Fields
             * @request GET:/datasets/fields
             * @secure
             */
            listDatasetFields: (params = {}) => this.request({
                path: `/datasets/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete dataset. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags datasets
             * @name DeleteDataset
             * @summary Delete Dataset
             * @request DELETE:/datasets/{dataset_id}
             * @secure
             */
            deleteDataset: (datasetId, params = {}) => this.request({
                path: `/datasets/${datasetId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get dataset. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
             *
             * @tags datasets
             * @name GetDataset
             * @summary Get Dataset
             * @request GET:/datasets/{dataset_id}
             * @secure
             */
            getDataset: (datasetId, query, params = {}) => this.request({
                path: `/datasets/${datasetId}`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a dataset. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags datasets
             * @name UpdateDataset
             * @summary Update Dataset
             * @request PATCH:/datasets/{dataset_id}
             * @secure
             */
            updateDataset: (datasetId, data, params = {}) => this.request({
                path: `/datasets/${datasetId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get classes of this dataset. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
             *
             * @tags datasets
             * @name GetDatasetClasses
             * @summary Get Dataset Classes
             * @request GET:/datasets/{dataset_id}/classes
             * @secure
             */
            getDatasetClasses: (datasetId, query, params = {}) => this.request({
                path: `/datasets/${datasetId}/classes`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List dataset sources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
             *
             * @tags datasets
             * @name ListDatasetSources
             * @summary List Dataset Sources
             * @request GET:/datasets/{dataset_id}/sources
             * @secure
             */
            listDatasetSources: (datasetId, params = {}) => this.request({
                path: `/datasets/${datasetId}/sources`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.deployments = {
            /**
             * @description List all deployments. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name ListDeployments
             * @summary List Deployments
             * @request GET:/deployments
             * @secure
             */
            listDeployments: (query, params = {}) => this.request({
                path: `/deployments`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a Deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name CreateDeployment
             * @summary Create Deployment
             * @request POST:/deployments
             * @secure
             */
            createDeployment: (data, params = {}) => this.request({
                path: `/deployments`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List deployment fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name ListDeploymentFields
             * @summary List Deployment Fields
             * @request GET:/deployments/fields
             * @secure
             */
            listDeploymentFields: (params = {}) => this.request({
                path: `/deployments/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a Deployment placeholder. This Deployment placeholder can have dependencies on resources which do not have valid values yet. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name CreateDeploymentPlaceholder
             * @summary Create Deployment Placeholder
             * @request POST:/deployments/placeholder
             * @secure
             */
            createDeploymentPlaceholder: (data, params = {}) => this.request({
                path: `/deployments/placeholder`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Register an external deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name RegisterExternalDeployment
             * @summary Register External Deployment
             * @request POST:/deployments/register
             * @secure
             */
            registerExternalDeployment: (data, params = {}) => this.request({
                path: `/deployments/register`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name DeleteDeployment
             * @summary Delete Deployment
             * @request DELETE:/deployments/{deployment_id}
             * @secure
             */
            deleteDeployment: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a deployment. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeployment
             * @summary Get Deployment
             * @request GET:/deployments/{deployment_id}
             * @secure
             */
            getDeployment: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name UpdateDeployment
             * @summary Update Deployment
             * @request PATCH:/deployments/{deployment_id}
             * @secure
             */
            updateDeployment: (deploymentId, data, params = {}) => this.request({
                path: `/deployments/${deploymentId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get deployment api endpoints info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeploymentApiEndpoints
             * @summary Get Deployment Api Endpoints
             * @request GET:/deployments/{deployment_id}/api-endpoints
             * @secure
             */
            getDeploymentApiEndpoints: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/api-endpoints`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get artifacts of a deployment. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeploymentArtifacts
             * @summary Get Deployment Artifacts
             * @request GET:/deployments/{deployment_id}/artifacts
             * @secure
             */
            getDeploymentArtifacts: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/artifacts`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get deployment dependencies. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeploymentDependencies
             * @summary Get Deployment Dependencies
             * @request GET:/deployments/{deployment_id}/dependencies
             * @secure
             */
            getDeploymentDependencies: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/dependencies`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Log heartbeat for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name LogHeartbeat
             * @summary Log Heartbeat
             * @request PATCH:/deployments/{deployment_id}/heartbeat
             * @secure
             */
            logHeartbeat: (deploymentId, data, params = {}) => this.request({
                path: `/deployments/${deploymentId}/heartbeat`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description Render the deployment's Inference Graph. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeploymentInferenceGraph
             * @summary Get Deployment Inference Graph
             * @request GET:/deployments/{deployment_id}/inference-graph
             * @secure
             */
            getDeploymentInferenceGraph: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/inference-graph`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get logs of a deployment. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name GetDeploymentLogs
             * @summary Get Deployment Logs
             * @request GET:/deployments/{deployment_id}/logs
             * @secure
             */
            getDeploymentLogs: (deploymentId, query, params = {}) => this.request({
                path: `/deployments/${deploymentId}/logs`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description Save logs to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name SaveDeploymentLogs
             * @summary Save Deployment Logs
             * @request POST:/deployments/{deployment_id}/logs
             * @secure
             */
            saveDeploymentLogs: (deploymentId, data, params = {}) => this.request({
                path: `/deployments/${deploymentId}/logs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Get latest status messages of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name ListDeploymentMessages
             * @summary List Deployment Messages
             * @request GET:/deployments/{deployment_id}/messages
             * @secure
             */
            listDeploymentMessages: (deploymentId, query, params = {}) => this.request({
                path: `/deployments/${deploymentId}/messages`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Log a status message for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name LogDeploymentMessage
             * @summary Log Deployment Message
             * @request POST:/deployments/{deployment_id}/messages
             * @secure
             */
            logDeploymentMessage: (deploymentId, data, params = {}) => this.request({
                path: `/deployments/${deploymentId}/messages`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description List deployment message fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name ListDeploymentMessageFields
             * @summary List Deployment Message Fields
             * @request GET:/deployments/{deployment_id}/messages/fields
             * @secure
             */
            listDeploymentMessageFields: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/messages/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Start a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name StartDeployment
             * @summary Start Deployment
             * @request POST:/deployments/{deployment_id}/start
             * @secure
             */
            startDeployment: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/start`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update status to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name UpdateDeploymentStatus
             * @summary Update Deployment Status
             * @request PATCH:/deployments/{deployment_id}/status
             * @secure
             */
            updateDeploymentStatus: (deploymentId, data, params = {}) => this.request({
                path: `/deployments/${deploymentId}/status`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Stop a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags deployments
             * @name StopDeployment
             * @summary Stop Deployment
             * @request POST:/deployments/{deployment_id}/stop
             * @secure
             */
            stopDeployment: (deploymentId, params = {}) => this.request({
                path: `/deployments/${deploymentId}/stop`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.entitlements = {
            /**
             * @description Return premium feature statuses (all features, or the queried subset). LIMIT features the licence carries report a live ``used`` count and their cap whatever their state, so a feature whose grant is not in force can still be shown with its numbers; features the licence never carried report ``not_granted``.
             *
             * @tags entitlements
             * @name GetEntitlements
             * @summary Get Entitlements
             * @request GET:/entitlements
             * @secure
             */
            getEntitlements: (query, params = {}) => this.request({
                path: `/entitlements`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.errors = {
            /**
             * @description List application errors.
             *
             * @tags monitor
             * @name ListErrors
             * @summary List Errors
             * @request GET:/errors
             * @secure
             */
            listErrors: (params = {}) => this.request({
                path: `/errors`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.exampleStreams = {
            /**
             * @description List example streams. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name ListExampleStreams
             * @summary List Example Streams
             * @request GET:/example-streams
             * @secure
             */
            listExampleStreams: (query, params = {}) => this.request({
                path: `/example-streams`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name CreateExampleStream
             * @summary Create Example Stream
             * @request POST:/example-streams
             * @secure
             */
            createExampleStream: (data, params = {}) => this.request({
                path: `/example-streams`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Disable an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name DeleteExampleStream
             * @summary Delete Example Stream
             * @request DELETE:/example-streams/{example_stream_id}
             * @secure
             */
            deleteExampleStream: (exampleStreamId, query, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}`,
                method: "DELETE",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get example stream. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name GetExampleStream
             * @summary Get Example Stream
             * @request GET:/example-streams/{example_stream_id}
             * @secure
             */
            getExampleStream: (exampleStreamId, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name UpdateExampleStream
             * @summary Update Example Stream
             * @request PATCH:/example-streams/{example_stream_id}
             * @secure
             */
            updateExampleStream: (exampleStreamId, data, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name GetCameraConfigData
             * @summary Get Camera Config Data
             * @request GET:/example-streams/{example_stream_id}/cameras/{camera_id}/config
             * @secure
             */
            getCameraConfigData: (exampleStreamId, cameraId, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/cameras/${cameraId}/config`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description Update example stream config status. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name UpdateExampleStreamConfigStatus
             * @summary Update Example Stream Config Status
             * @request PUT:/example-streams/{example_stream_id}/config-status
             * @secure
             */
            updateExampleStreamConfigStatus: (exampleStreamId, data, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/config-status`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Revalidate an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name RevalidateExampleStream
             * @summary Revalidate Example Stream
             * @request POST:/example-streams/{example_stream_id}/revalidate
             * @secure
             */
            revalidateExampleStream: (exampleStreamId, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/revalidate`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update example stream status. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name UpdateExampleStreamStatus
             * @summary Update Example Stream Status
             * @request PUT:/example-streams/{example_stream_id}/status
             * @secure
             */
            updateExampleStreamStatus: (exampleStreamId, query, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/status`,
                method: "PUT",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Stop validation of an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name StopValidationExampleStream
             * @summary Stop Validation Example Stream
             * @request POST:/example-streams/{example_stream_id}/stop-validation
             * @secure
             */
            stopValidationExampleStream: (exampleStreamId, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/stop-validation`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name GetValidationLogs
             * @summary Get Validation Logs
             * @request GET:/example-streams/{example_stream_id}/validation-logs
             * @secure
             */
            getValidationLogs: (exampleStreamId, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/validation-logs`,
                method: "GET",
                secure: true,
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name AddValidationLogs
             * @summary Add Validation Logs
             * @request PUT:/example-streams/{example_stream_id}/validation-logs
             * @secure
             */
            addValidationLogs: (exampleStreamId, data, params = {}) => this.request({
                path: `/example-streams/${exampleStreamId}/validation-logs`,
                method: "PUT",
                body: data,
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.info = {
            /**
             * @description Get platform info.
             *
             * @tags monitor
             * @name GetInfo
             * @summary Get Info
             * @request GET:/info
             * @secure
             */
            getInfo: (params = {}) => this.request({
                path: `/info`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.jobs = {
            /**
             * @description List all jobs. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name ListJobs
             * @summary List Jobs
             * @request GET:/jobs
             * @secure
             */
            listJobs: (query, params = {}) => this.request({
                path: `/jobs`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Start a job. All parameters (parameters, models, datasets) are linked with the `job_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
             *
             * @tags jobs
             * @name StartJob
             * @summary Start Job
             * @request POST:/jobs
             * @secure
             */
            startJob: (data, params = {}) => this.request({
                path: `/jobs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List job fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name ListJobFields
             * @summary List Job Fields
             * @request GET:/jobs/fields
             * @secure
             */
            listJobFields: (params = {}) => this.request({
                path: `/jobs/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Register an external job. Alternative for start_job, but without actually starting the job. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
             *
             * @tags jobs
             * @name RegisterExternalJob
             * @summary Register External Job
             * @request POST:/jobs/register
             * @secure
             */
            registerExternalJob: (data, params = {}) => this.request({
                path: `/jobs/register`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a job. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags jobs
             * @name DeleteJob
             * @summary Delete Job
             * @request DELETE:/jobs/{job_id}
             * @secure
             */
            deleteJob: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a job. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name GetJob
             * @summary Get Job
             * @request GET:/jobs/{job_id}
             * @secure
             */
            getJob: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get job api endpoints info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
             *
             * @tags jobs
             * @name GetJobApiEndpoints
             * @summary Get Job Api Endpoints
             * @request GET:/jobs/{job_id}/api-endpoints
             * @secure
             */
            getJobApiEndpoints: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/api-endpoints`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get artifacts of a job. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
             *
             * @tags jobs
             * @name GetJobArtifacts
             * @summary Get Job Artifacts
             * @request GET:/jobs/{job_id}/artifacts
             * @secure
             */
            getJobArtifacts: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/artifacts`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name GetJobCreator
             * @summary Get Job Creator
             * @request GET:/jobs/{job_id}/creator
             * @secure
             */
            getJobCreator: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/creator`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get job dependencies. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
             *
             * @tags jobs
             * @name GetJobDependencies
             * @summary Get Job Dependencies
             * @request GET:/jobs/{job_id}/dependencies
             * @secure
             */
            getJobDependencies: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/dependencies`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get logs of a job. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name GetJobLogs
             * @summary Get Job Logs
             * @request GET:/jobs/{job_id}/logs
             * @secure
             */
            getJobLogs: (jobId, query, params = {}) => this.request({
                path: `/jobs/${jobId}/logs`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description Save logs to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name SaveJobLogs
             * @summary Save Job Logs
             * @request PUT:/jobs/{job_id}/logs
             * @secure
             */
            saveJobLogs: (jobId, data, params = {}) => this.request({
                path: `/jobs/${jobId}/logs`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Get latest status messages of a job. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name ListJobMessages
             * @summary List Job Messages
             * @request GET:/jobs/{job_id}/messages
             * @secure
             */
            listJobMessages: (jobId, query, params = {}) => this.request({
                path: `/jobs/${jobId}/messages`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Log a status message for a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name LogJobMessage
             * @summary Log Job Message
             * @request POST:/jobs/{job_id}/messages
             * @secure
             */
            logJobMessage: (jobId, data, params = {}) => this.request({
                path: `/jobs/${jobId}/messages`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params,
            }),
            /**
             * @description List job message fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name ListJobMessageFields
             * @summary List Job Message Fields
             * @request GET:/jobs/{job_id}/messages/fields
             * @secure
             */
            listJobMessageFields: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/messages/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update the metadata of a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name UpdateJobMetadata
             * @summary Update Job Metadata
             * @request PUT:/jobs/{job_id}/metadata
             * @secure
             */
            updateJobMetadata: (jobId, data, params = {}) => this.request({
                path: `/jobs/${jobId}/metadata`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Update status to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name UpdateJobStatus
             * @summary Update Job Status
             * @request POST:/jobs/{job_id}/status
             * @secure
             */
            updateJobStatus: (jobId, data, params = {}) => this.request({
                path: `/jobs/${jobId}/status`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Stop a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags jobs
             * @name StopJob
             * @summary Stop Job
             * @request POST:/jobs/{job_id}/stop
             * @secure
             */
            stopJob: (jobId, params = {}) => this.request({
                path: `/jobs/${jobId}/stop`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.livez = {
            /**
             * @description Get application heartbeat.
             *
             * @tags monitor
             * @name GetHeartbeat
             * @summary Get Heartbeat
             * @request GET:/livez
             * @secure
             */
            getHeartbeat: (params = {}) => this.request({
                path: `/livez`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.logs = {
            /**
             * @description Prepare server logs.
             *
             * @tags monitor
             * @name PrepareLogs
             * @summary Prepare Logs
             * @request POST:/logs
             * @secure
             */
            prepareLogs: (query, params = {}) => this.request({
                path: `/logs`,
                method: "POST",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Download server logs.
             *
             * @tags monitor
             * @name DownloadLogs
             * @summary Download Logs
             * @request GET:/logs/{zip_filename}
             * @secure
             */
            downloadLogs: (zipFilename, params = {}) => this.request({
                path: `/logs/${zipFilename}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.platformConnection = {
            /**
             * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name DeletePlatformConnection
             * @summary Delete Platform Connection
             * @request DELETE:/platform-connection
             * @secure
             */
            deletePlatformConnection: (params = {}) => this.request({
                path: `/platform-connection`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetPlatformConnection
             * @summary Get Platform Connection
             * @request GET:/platform-connection
             * @secure
             */
            getPlatformConnection: (params = {}) => this.request({
                path: `/platform-connection`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name CreatePlatformConnection
             * @summary Create Platform Connection
             * @request POST:/platform-connection
             * @secure
             */
            createPlatformConnection: (data, params = {}) => this.request({
                path: `/platform-connection`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List the inference slots the connected Indurion Agents advertised. Each agent pushes its full slot list over the WebSocket on connect and on every change; the Hub answers from that last advertisement, so this call involves no agent round-trip. Deregistered slots are left out unless ``include_deregistered`` is set. An agent with no listed slots appears with an empty list; agents that are disconnected — or connected but yet to advertise — are omitted entirely. An ``AdvertisedInferenceSlotsChangedEvent`` is broadcast over SSE whenever an agent's slots change, so listeners can re-fetch instead of polling. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ListAdvertisedInferenceSlots
             * @summary List Advertised Inference Slots
             * @request GET:/platform-connection/advertised-inference-slots
             * @secure
             */
            listAdvertisedInferenceSlots: (query, params = {}) => this.request({
                path: `/platform-connection/advertised-inference-slots`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Return the IDs of all child platforms that have any stored log files. Useful for a quick overview of which Indurion Agents have collected logs without having to probe each platform individually. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ListPlatformsWithAgentLogs
             * @summary List Platforms With Agent Logs
             * @request GET:/platform-connection/agent-logs
             * @secure
             */
            listPlatformsWithAgentLogs: (query, params = {}) => this.request({
                path: `/platform-connection/agent-logs`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ListAlgorithmsFromConnection
             * @summary List Algorithms From Connection
             * @request GET:/platform-connection/algorithms
             * @secure
             */
            listAlgorithmsFromConnection: (query, params = {}) => this.request({
                path: `/platform-connection/algorithms`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List commissioning requests. Returns requests with every outcome by default. `decision` narrows to a single outcome (`APPROVED`/`REJECTED`) or to requests still pending one (`PENDING`). **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags commissioning
             * @name ListCommissioningRequests
             * @summary List Commissioning Requests
             * @request GET:/platform-connection/commissioning-requests
             * @secure
             */
            listCommissioningRequests: (query, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Register the calling agent's request to join this platform's network. Refused when the license never had the `indurion_agent` entitlement (or its value disabled it); Entitlements are used to decide whether the pending-approval notification is fired.
             *
             * @tags commissioning
             * @name CreateCommissioningRequest
             * @summary Create Commissioning Request
             * @request POST:/platform-connection/commissioning-requests/register
             * @secure
             */
            createCommissioningRequest: (data, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests/register`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get the latest commissioning request for a platform.
             *
             * @tags commissioning
             * @name GetLatestCommissioningStatus
             * @summary Get Latest Commissioning Status
             * @request GET:/platform-connection/commissioning-requests/status
             * @secure
             */
            getLatestCommissioningStatus: (query, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests/status`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a single commissioning request by ID. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags commissioning
             * @name GetCommissioningRequest
             * @summary Get Commissioning Request
             * @request GET:/platform-connection/commissioning-requests/{request_id}
             * @secure
             */
            getCommissioningRequest: (requestId, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests/${requestId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Approve a commissioning request and register its trusted key. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags commissioning
             * @name ApproveCommissioningRequest
             * @summary Approve Commissioning Request
             * @request POST:/platform-connection/commissioning-requests/{request_id}/approve
             * @secure
             */
            approveCommissioningRequest: (requestId, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests/${requestId}/approve`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Reject a commissioning request. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags commissioning
             * @name RejectCommissioningRequest
             * @summary Reject Commissioning Request
             * @request POST:/platform-connection/commissioning-requests/{request_id}/reject
             * @secure
             */
            rejectCommissioningRequest: (requestId, params = {}) => this.request({
                path: `/platform-connection/commissioning-requests/${requestId}/reject`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ListDeploymentsFromConnection
             * @summary List Deployments From Connection
             * @request GET:/platform-connection/deployments
             * @secure
             */
            listDeploymentsFromConnection: (query, params = {}) => this.request({
                path: `/platform-connection/deployments`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetDeploymentDependenciesFromConnection
             * @summary Get Deployment Dependencies From Connection
             * @request GET:/platform-connection/deployments/{deployment_id}/dependencies
             * @secure
             */
            getDeploymentDependenciesFromConnection: (deploymentId, params = {}) => this.request({
                path: `/platform-connection/deployments/${deploymentId}/dependencies`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetPlatformConnectionsNetworkOverview
             * @summary Get Platform Connections Network Overview
             * @request GET:/platform-connection/network-overview
             * @secure
             */
            getPlatformConnectionsNetworkOverview: (params = {}) => this.request({
                path: `/platform-connection/network-overview`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name DeleteDeploymentsBatch
             * @summary Delete Deployments Batch
             * @request DELETE:/platform-connection/platform-deployments
             * @secure
             */
            deleteDeploymentsBatch: (data, query, params = {}) => this.request({
                path: `/platform-connection/platform-deployments`,
                method: "DELETE",
                query: query,
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name PlatformConnectionListDeployments
             * @summary List Deployments
             * @request GET:/platform-connection/platform-deployments
             * @secure
             */
            platformConnectionListDeployments: (query, params = {}) => this.request({
                path: `/platform-connection/platform-deployments`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name CreateDeploymentsBatch
             * @summary Create Deployments Batch
             * @request POST:/platform-connection/platform-deployments
             * @secure
             */
            createDeploymentsBatch: (data, params = {}) => this.request({
                path: `/platform-connection/platform-deployments`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name PlatformConnectionDeleteDeployment
             * @summary Delete Deployment
             * @request DELETE:/platform-connection/platform-deployments/{id}
             * @secure
             */
            platformConnectionDeleteDeployment: (id, query, params = {}) => this.request({
                path: `/platform-connection/platform-deployments/${id}`,
                method: "DELETE",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a platform deployment by ID. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name PlatformConnectionGetDeployment
             * @summary Get Deployment
             * @request GET:/platform-connection/platform-deployments/{id}
             * @secure
             */
            platformConnectionGetDeployment: (id, params = {}) => this.request({
                path: `/platform-connection/platform-deployments/${id}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name UpdateDeploymentActualStatus
             * @summary Update Deployment Actual Status
             * @request PATCH:/platform-connection/platform-deployments/{id}/actual-status
             * @secure
             */
            updateDeploymentActualStatus: (id, data, params = {}) => this.request({
                path: `/platform-connection/platform-deployments/${id}/actual-status`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name UpdateDeploymentDesiredStatus
             * @summary Update Deployment Desired Status
             * @request PATCH:/platform-connection/platform-deployments/{id}/desired-status
             * @secure
             */
            updateDeploymentDesiredStatus: (id, data, params = {}) => this.request({
                path: `/platform-connection/platform-deployments/${id}/desired-status`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a single platform, enriched with its connection info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetPlatformWithConnection
             * @summary Get Platform With Connection
             * @request GET:/platform-connection/platforms/{platform_id}
             * @secure
             */
            getPlatformWithConnection: (platformId, params = {}) => this.request({
                path: `/platform-connection/platforms/${platformId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a connected agent and remove it from the topology. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name DeletePlatform
             * @summary Delete Platform
             * @request POST:/platform-connection/platforms/{platform_id}/delete
             * @secure
             */
            deletePlatform: (platformId, data, params = {}) => this.request({
                path: `/platform-connection/platforms/${platformId}/delete`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List all projects from the latest hub connection that are compatible with the current project. Compatible projects are projects with the same algorithm type. If no connection id is provided, it defaults to the latest one that was set up. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ListProjectsFromConnection
             * @summary List Projects From Connection
             * @request GET:/platform-connection/projects
             * @secure
             */
            listProjectsFromConnection: (query, params = {}) => this.request({
                path: `/platform-connection/projects`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD EDGE * DATA_UPLOAD MODEL_CREATION * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetParametersResourceDataFromConnection
             * @summary Get Parameters Resource Data From Connection
             * @request GET:/platform-connection/resources/parameters/{resource_id}/data
             * @secure
             */
            getParametersResourceDataFromConnection: (resourceId, params = {}) => this.request({
                path: `/platform-connection/resources/parameters/${resourceId}/data`,
                method: "GET",
                secure: true,
                format: "arraybuffer",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ValidatePlatformConnection
             * @summary Validate Platform Connection
             * @request GET:/platform-connection/validate
             * @secure
             */
            validatePlatformConnection: (params = {}) => this.request({
                path: `/platform-connection/validate`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name ValidateCredentials
             * @summary Validate Credentials
             * @request POST:/platform-connection/validate
             * @secure
             */
            validateCredentials: (data, params = {}) => this.request({
                path: `/platform-connection/validate`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Download collected log files for a platform/agent as a ZIP archive. Files are packed preserving the `<service>/YYYY-MM-DD[-N].log` path hierarchy inside the archive. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name DownloadAgentLogs
             * @summary Download Agent Logs
             * @request GET:/platform-connection/{platform_id}/agent-logs
             * @secure
             */
            downloadAgentLogs: (platformId, query, params = {}) => this.request({
                path: `/platform-connection/${platformId}/agent-logs`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
            /**
             * @description This endpoint is to be used to get the desired deployments for a platform. Typically, it is called by the agent that needs to know the desired deployments for a platform. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * SYSTEM_MANAGEMENT
             *
             * @tags platform_connection
             * @name GetDesiredDeployments
             * @summary Get Desired Deployments
             * @request GET:/platform-connection/{platform_id}/platform-deployments/desired
             * @secure
             */
            getDesiredDeployments: (platformId, params = {}) => this.request({
                path: `/platform-connection/${platformId}/platform-deployments/desired`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.pleoraLicense = {
            /**
             * @description Get current Pleora license metadata and validation status. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags pleora-license
             * @name GetPleoraLicense
             * @summary Get Pleora License
             * @request GET:/pleora-license
             * @secure
             */
            getPleoraLicense: (params = {}) => this.request({
                path: `/pleora-license`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Upload or replace Pleora license file. The license file must have a .lic extension and the filename should contain a valid MAC address that matches the host system. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags pleora-license
             * @name UploadPleoraLicense
             * @summary Upload Pleora License
             * @request PUT:/pleora-license
             * @secure
             */
            uploadPleoraLicense: (data, params = {}) => this.request({
                path: `/pleora-license`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.FormData,
                ...params,
            }),
            /**
             * @description Download the Pleora license file. **Accepted permissions:** * SYSTEM_MANAGEMENT
             *
             * @tags pleora-license
             * @name DownloadPleoraLicense
             * @summary Download Pleora License
             * @request GET:/pleora-license/file
             * @secure
             */
            downloadPleoraLicense: (params = {}) => this.request({
                path: `/pleora-license/file`,
                method: "GET",
                secure: true,
                format: "arraybuffer",
                ...params,
            }),
        };
        this.projects = {
            /**
             * @description List all projects. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name ListProjects
             * @summary List Projects
             * @request GET:/projects
             * @secure
             */
            listProjects: (query, params = {}) => this.request({
                path: `/projects`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a project. **Accepted permissions:** * PROJECT_CREATION
             *
             * @tags projects
             * @name CreateProject
             * @summary Create Project
             * @request POST:/projects
             * @secure
             */
            createProject: (data, params = {}) => this.request({
                path: `/projects`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List project fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name ListProjectFields
             * @summary List Project Fields
             * @request GET:/projects/fields
             * @secure
             */
            listProjectFields: (params = {}) => this.request({
                path: `/projects/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List all project metadata. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name ListProjectMetadata
             * @summary List Project Metadata
             * @request GET:/projects/metadata
             * @secure
             */
            listProjectMetadata: (params = {}) => this.request({
                path: `/projects/metadata`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a project by its name. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name GetProjectByName
             * @summary Get Project By Name
             * @request GET:/projects/name/{project_name}
             * @secure
             */
            getProjectByName: (projectName, params = {}) => this.request({
                path: `/projects/name/${projectName}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Check project name's existence. **Accepted permissions:** * PROJECT_CREATION
             *
             * @tags projects
             * @name IsProjectNameAvailable
             * @summary Is Project Name Available
             * @request GET:/projects/name/{project_name}/availability
             * @secure
             */
            isProjectNameAvailable: (projectName, params = {}) => this.request({
                path: `/projects/name/${projectName}/availability`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a project. **Accepted permissions:** * INFERENCE MODEL_CREATION PROJECT_CREATION * MODEL_CREATION PROJECT_CREATION SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name DeleteProject
             * @summary Delete Project
             * @request DELETE:/projects/{project_id}
             * @secure
             */
            deleteProject: (projectId, params = {}) => this.request({
                path: `/projects/${projectId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a project. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name GetProject
             * @summary Get Project
             * @request GET:/projects/{project_id}
             * @secure
             */
            getProject: (projectId, params = {}) => this.request({
                path: `/projects/${projectId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a project. **Accepted permissions:** * PROJECT_CREATION
             *
             * @tags projects
             * @name UpdateProject
             * @summary Update Project
             * @request PATCH:/projects/{project_id}
             * @secure
             */
            updateProject: (projectId, data, params = {}) => this.request({
                path: `/projects/${projectId}`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Update a default algorithm in project. **Accepted permissions:** * PROJECT_CREATION
             *
             * @tags projects
             * @name UpdateProjectDefaultAlgorithm
             * @summary Update Project Default Algorithm
             * @request PATCH:/projects/{project_id}/algorithm
             * @secure
             */
            updateProjectDefaultAlgorithm: (projectId, data, params = {}) => this.request({
                path: `/projects/${projectId}/algorithm`,
                method: "PATCH",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get default project example definitions. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name GetDefaultProjectExampleDefinitions
             * @summary Get Default Project Example Definitions
             * @request GET:/projects/{project_id}/example-definitions
             * @secure
             */
            getDefaultProjectExampleDefinitions: (projectId, params = {}) => this.request({
                path: `/projects/${projectId}/example-definitions`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get project thumbnail. Supports authorization via ?token. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags projects
             * @name GetProjectThumbnail
             * @summary Get Project Thumbnail
             * @request GET:/projects/{project_id}/thumbnail
             * @secure
             */
            getProjectThumbnail: (projectId, query, params = {}) => this.request({
                path: `/projects/${projectId}/thumbnail`,
                method: "GET",
                query: query,
                secure: true,
                format: "blob",
                ...params,
            }),
        };
        this.prometheus = {
            /**
             * No description
             *
             * @tags monitor
             * @name GetPrometheusMetrics
             * @summary Get Prometheus Metrics
             * @request GET:/prometheus
             * @secure
             */
            getPrometheusMetrics: (params = {}) => this.request({
                path: `/prometheus`,
                method: "GET",
                secure: true,
                ...params,
            }),
        };
        this.resources = {
            /**
             * @description List resources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name ListResources
             * @summary List Resources
             * @request GET:/resources/
             * @secure
             */
            listResources: (query, params = {}) => this.request({
                path: `/resources/`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List blob resources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name ListBlobResources
             * @summary List Blob Resources
             * @request GET:/resources/blobs
             * @secure
             */
            listBlobResources: (query, params = {}) => this.request({
                path: `/resources/blobs`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create generic blob resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name CreateBlobResource
             * @summary Create Blob Resource
             * @request POST:/resources/blobs
             * @secure
             */
            createBlobResource: (data, params = {}) => this.request({
                path: `/resources/blobs`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get blob resource info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetBlobResourceInfo
             * @summary Get Blob Resource Info
             * @request GET:/resources/blobs/{resource_id}
             * @secure
             */
            getBlobResourceInfo: (resourceId, params = {}) => this.request({
                path: `/resources/blobs/${resourceId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Override blob resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name OverrideBlobResourceMetadata
             * @summary Override Blob Resource Metadata
             * @request PUT:/resources/blobs/{resource_id}
             * @secure
             */
            overrideBlobResourceMetadata: (resourceId, data, params = {}) => this.request({
                path: `/resources/blobs/${resourceId}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get blob resource data. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetBlobResourceData
             * @summary Get Blob Resource Data
             * @request GET:/resources/blobs/{resource_id}/data
             * @secure
             */
            getBlobResourceData: (resourceId, query, params = {}) => this.request({
                path: `/resources/blobs/${resourceId}/data`,
                method: "GET",
                query: query,
                secure: true,
                format: "arraybuffer",
                ...params,
            }),
            /**
             * @description Put blob resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name PutBlobResourceData
             * @summary Put Blob Resource Data
             * @request PUT:/resources/blobs/{resource_id}/data
             * @secure
             */
            putBlobResourceData: (resourceId, data, params = {}) => this.request({
                path: `/resources/blobs/${resourceId}/data`,
                method: "PUT",
                body: data,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List resource fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name ListResourceFields
             * @summary List Resource Fields
             * @request GET:/resources/fields
             * @secure
             */
            listResourceFields: (params = {}) => this.request({
                path: `/resources/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List model resources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name ListModelResources
             * @summary List Model Resources
             * @request GET:/resources/models
             * @secure
             */
            listModelResources: (query, params = {}) => this.request({
                path: `/resources/models`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create model resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name CreateModelResource
             * @summary Create Model Resource
             * @request POST:/resources/models
             * @secure
             */
            createModelResource: (data, params = {}) => this.request({
                path: `/resources/models`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get model resource info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetModelResourceInfo
             * @summary Get Model Resource Info
             * @request GET:/resources/models/{resource_id}
             * @secure
             */
            getModelResourceInfo: (resourceId, params = {}) => this.request({
                path: `/resources/models/${resourceId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Override models resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name OverrideModelResourceMetadata
             * @summary Override Model Resource Metadata
             * @request PUT:/resources/models/{resource_id}
             * @secure
             */
            overrideModelResourceMetadata: (resourceId, data, params = {}) => this.request({
                path: `/resources/models/${resourceId}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get model resource data. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetModelResourceData
             * @summary Get Model Resource Data
             * @request GET:/resources/models/{resource_id}/data
             * @secure
             */
            getModelResourceData: (resourceId, query, params = {}) => this.request({
                path: `/resources/models/${resourceId}/data`,
                method: "GET",
                query: query,
                secure: true,
                format: "arraybuffer",
                ...params,
            }),
            /**
             * @description Put model resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name PutModelResourceData
             * @summary Put Model Resource Data
             * @request PUT:/resources/models/{resource_id}/data
             * @secure
             */
            putModelResourceData: (resourceId, data, params = {}) => this.request({
                path: `/resources/models/${resourceId}/data`,
                method: "PUT",
                body: data,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description List parameters resources. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name ListParametersResources
             * @summary List Parameters Resources
             * @request GET:/resources/parameters
             * @secure
             */
            listParametersResources: (query, params = {}) => this.request({
                path: `/resources/parameters`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Create a parameters resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name CreateParametersResource
             * @summary Create Parameters Resource
             * @request POST:/resources/parameters
             * @secure
             */
            createParametersResource: (data, params = {}) => this.request({
                path: `/resources/parameters`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
            /**
             * @description Create parameters resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name CreateParametersResourceWithUploadUrl
             * @summary Create Parameters Resource With Upload Url
             * @request POST:/resources/parameters/metadata
             * @secure
             */
            createParametersResourceWithUploadUrl: (data, params = {}) => this.request({
                path: `/resources/parameters/metadata`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get parameters resource info. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetParametersResourceInfo
             * @summary Get Parameters Resource Info
             * @request GET:/resources/parameters/{resource_id}
             * @secure
             */
            getParametersResourceInfo: (resourceId, params = {}) => this.request({
                path: `/resources/parameters/${resourceId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Override parameters resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name OverrideParametersResourceMetadata
             * @summary Override Parameters Resource Metadata
             * @request PUT:/resources/parameters/{resource_id}
             * @secure
             */
            overrideParametersResourceMetadata: (resourceId, data, params = {}) => this.request({
                path: `/resources/parameters/${resourceId}`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Get parameters resource data. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetParametersResourceData
             * @summary Get Parameters Resource Data
             * @request GET:/resources/parameters/{resource_id}/data
             * @secure
             */
            getParametersResourceData: (resourceId, query, params = {}) => this.request({
                path: `/resources/parameters/${resourceId}/data`,
                method: "GET",
                query: query,
                secure: true,
                format: "arraybuffer",
                ...params,
            }),
            /**
             * @description Put parameters resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name PutParametersResourceData
             * @summary Put Parameters Resource Data
             * @request PUT:/resources/parameters/{resource_id}/data
             * @secure
             */
            putParametersResourceData: (resourceId, data, params = {}) => this.request({
                path: `/resources/parameters/${resourceId}/data`,
                method: "PUT",
                body: data,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get parameters resource definition. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * EDGE * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name GetParametersResourceDefinition
             * @summary Get Parameters Resource Definition
             * @request GET:/resources/parameters/{resource_id}/definition
             * @secure
             */
            getParametersResourceDefinition: (resourceId, params = {}) => this.request({
                path: `/resources/parameters/${resourceId}/definition`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
             *
             * @tags resources
             * @name DeleteResource
             * @summary Delete Resource
             * @request DELETE:/resources/{resource_id}
             * @secure
             */
            deleteResource: (resourceId, params = {}) => this.request({
                path: `/resources/${resourceId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.schemas = {
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags schemas
             * @name GetDatapoolDefinition
             * @summary Get Datapool Definition
             * @request GET:/schemas/datapool/{definition_id}
             * @secure
             */
            getDatapoolDefinition: (definitionId, params = {}) => this.request({
                path: `/schemas/datapool/${definitionId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.sse = {
            /**
             * No description
             *
             * @tags sse
             * @name GetEvents
             * @summary Get Events
             * @request GET:/sse
             * @secure
             */
            getEvents: (query, params = {}) => this.request({
                path: `/sse`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
        };
        this.storageCapacity = {
            /**
             * No description
             *
             * @tags storage_capacity
             * @name GetStorageCapacities
             * @summary Get Storage Capacities
             * @request GET:/storage-capacity
             * @secure
             */
            getStorageCapacities: (params = {}) => this.request({
                path: `/storage-capacity`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.termsAndConditions = {
            /**
             * @description Returns the terms and conditions as a PDF. If the terms and conditions have not been overridden, the default terms and conditions should be shown.
             *
             * @tags monitor
             * @name GetTermsAndConditions
             * @summary Get Terms And Conditions
             * @request GET:/terms-and-conditions/pdf
             * @secure
             */
            getTermsAndConditions: (query, params = {}) => this.request({
                path: `/terms-and-conditions/pdf`,
                method: "GET",
                query: query,
                secure: true,
                ...params,
            }),
        };
        this.version = {
            /**
             * @description [DEPRECATED] Returns the application version. Use `/info` instead.
             *
             * @tags monitor
             * @name GetVersion
             * @summary Get Version
             * @request GET:/version
             * @deprecated
             * @secure
             */
            getVersion: (params = {}) => this.request({
                path: `/version`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.viewTemplates = {
            /**
             * @description **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags example_streams
             * @name ListExampleStreamViewTemplates
             * @summary List Example Stream View Templates
             * @request GET:/view-templates
             * @secure
             */
            listExampleStreamViewTemplates: (params = {}) => this.request({
                path: `/view-templates`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
        };
        this.workflows = {
            /**
             * @description List all workflows. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name ListWorkflows
             * @summary List Workflows
             * @request GET:/workflows
             * @secure
             */
            listWorkflows: (query, params = {}) => this.request({
                path: `/workflows`,
                method: "GET",
                query: query,
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Start a workflow. All parameters (parameters, models, datasets) are linked with the `workflow_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
             *
             * @tags workflows
             * @name StartWorkflow
             * @summary Start Workflow
             * @request POST:/workflows
             * @secure
             */
            startWorkflow: (data, params = {}) => this.request({
                path: `/workflows`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description List workflow fields. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name ListWorkflowFields
             * @summary List Workflow Fields
             * @request GET:/workflows/fields
             * @secure
             */
            listWorkflowFields: (params = {}) => this.request({
                path: `/workflows/fields`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Register an external workflow. Alternative for start_workflow, but without actually starting the workflow. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
             *
             * @tags workflows
             * @name RegisterExternalWorkflow
             * @summary Register External Workflow
             * @request POST:/workflows/register
             * @secure
             */
            registerExternalWorkflow: (data, params = {}) => this.request({
                path: `/workflows/register`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Delete a workflow. **Accepted permissions:** * MODEL_CREATION
             *
             * @tags workflows
             * @name DeleteWorkflow
             * @summary Delete Workflow
             * @request DELETE:/workflows/{workflow_id}
             * @secure
             */
            deleteWorkflow: (workflowId, params = {}) => this.request({
                path: `/workflows/${workflowId}`,
                method: "DELETE",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Get a workflow. **Accepted permissions:** * COMMISSIONED_INDURION_AGENT * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name GetWorkflow
             * @summary Get Workflow
             * @request GET:/workflows/{workflow_id}
             * @secure
             */
            getWorkflow: (workflowId, params = {}) => this.request({
                path: `/workflows/${workflowId}`,
                method: "GET",
                secure: true,
                format: "json",
                ...params,
            }),
            /**
             * @description Update the metadata of a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name UpdateWorkflowMetadata
             * @summary Update Workflow Metadata
             * @request PUT:/workflows/{workflow_id}/metadata
             * @secure
             */
            updateWorkflowMetadata: (workflowId, data, params = {}) => this.request({
                path: `/workflows/${workflowId}/metadata`,
                method: "PUT",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Update status of workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name UpdateWorkflowStatus
             * @summary Update Workflow Status
             * @request POST:/workflows/{workflow_id}/status
             * @secure
             */
            updateWorkflowStatus: (workflowId, data, params = {}) => this.request({
                path: `/workflows/${workflowId}/status`,
                method: "POST",
                body: data,
                secure: true,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),
            /**
             * @description Stop a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
             *
             * @tags workflows
             * @name StopWorkflow
             * @summary Stop Workflow
             * @request POST:/workflows/{workflow_id}/stop
             * @secure
             */
            stopWorkflow: (workflowId, params = {}) => this.request({
                path: `/workflows/${workflowId}/stop`,
                method: "POST",
                secure: true,
                format: "json",
                ...params,
            }),
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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